/**
 * Coordinate type.
 */
export type coordinates = number;

/**
 * Type of geometries.
 */
export type Geometry<T extends coordinates, U extends coordinates> =
    | Polygon<T, U>
    | Point<T, U>
    | MultiPolygone<T, U>
    | Line<T, U>
    | Text<T, U>

/**
 * Polygone type.
 */
export type Polygon<T extends coordinates, U extends coordinates> = {
    type: "POLYGON",
    coordinates: [T, U][]
}

/**
 * Point type.
 */
export type Point<T extends coordinates, U extends coordinates> = {
    type: "POINT",
    coordinates: [T, U]
}

/**
 * Group of polygons type.
 */
export type MultiPolygone<T extends coordinates, U extends coordinates> = {
    type: "MULTIPOLYGON",
    coordinates: [T, U][][]
}

/**
 * Line type.
 */
export type Line<T extends coordinates, U extends coordinates> = {
    type: "LINE",
    coordinates: [[T, U], [T, U]]
}

/**
 * Text type.
 */
export type Text<T extends coordinates, U extends coordinates> = {
    type: "TEXT",
    coordinates: [T, U][]
}

/**
 * Predicate if geometry is a POINT
 */
export const isPoint = <T extends coordinates, U extends coordinates>(geom : Geometry<T,U>) : geom is Point<T,U> => {
    return geom.type === "POINT"
}